export default class EmergoResponse {
  public response_informative = ''
  public response_reactive = ''
}
